import React, { useState } from 'react';
import { IWordState } from '../../contexts/styledWordContext';
import { EditImageTool } from '../EditTool/EditImageTool';
import { ExemplarImage } from './ExemplarImage';
import { StyledImageFlexWrapper, StyledImageBorder } from '../Styled';
import { ImageDimensions, ImageSide } from '../../types';
import { DEFAULT_IMAGE_DIMENSIONS } from '../../constants/exemplar';
import { getHiddenImageId } from '../../utils';

interface IEditImage {
  editMode: boolean;
  uuid: string;
  default_uuid?: string;
  imageKey?: string;
  side: ImageSide;
  src: string;
  alt: string;
  styledWordState: IWordState;
  uploadImage: (
    id: string,
    default_uuid: string | undefined,
    sectionId: string,
    defaultDimensions: ImageDimensions,
    side?: ImageSide
  ) => void;
  hasPosition: boolean;
}

export const CLICKABLE_IMG = 'CLICKABLE_IMG';

export const EditImage: React.FC<IEditImage> = (props): JSX.Element => {
  const { editMode, uuid, default_uuid, imageKey, side, src, alt, styledWordState, uploadImage, hasPosition } = props;
  const [defaultImageDimensions, setDefaultImageDimensions] = useState<ImageDimensions>(DEFAULT_IMAGE_DIMENSIONS);
  const hiddenImageId = getHiddenImageId(default_uuid, uuid);
  const isBottom = side === ImageSide.bottom;

  const children = () => {
    return (
      <ExemplarImage
        width={100}
        height={100}
        data-testid="visible-image"
        isVisible={!styledWordState.images.includes(hiddenImageId)}
        className={CLICKABLE_IMG}
        src={src}
        alt={alt}
        setDefaultImageDimensions={setDefaultImageDimensions}
      />
    );
  };

  return (
    <StyledImageFlexWrapper hasPosition={hasPosition}>
      {editMode ? (
        <StyledImageBorder
          data-testid="image-border"
          tabIndex={0}
          editMode={editMode && styledWordState.imageTool.isVisible}
          isVisible={!styledWordState.images.includes(hiddenImageId)}
          hasPosition={hasPosition}
          showBorder={!isBottom}
        >
          {children()}
        </StyledImageBorder>
      ) : (
        <StyledImageBorder
          data-testid="image-border"
          editMode={editMode && styledWordState.imageTool.isVisible}
          isVisible={!styledWordState.images.includes(hiddenImageId)}
          hasPosition={hasPosition}
          showBorder={!isBottom}
        >
          {children()}
        </StyledImageBorder>
      )}
      {styledWordState.imageTool.isVisible && (
        <EditImageTool
          id={uuid}
          uuid={uuid}
          default_uuid={default_uuid}
          imageKey={imageKey}
          side={side}
          defaultImageDimensions={defaultImageDimensions}
          editMode={editMode}
          isUploadAvailable={!styledWordState.images.includes(getHiddenImageId(default_uuid, uuid))}
          uploadImage={uploadImage}
        />
      )}
    </StyledImageFlexWrapper>
  );
};
